import React from 'react';
import { useAuth } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

const AuthModal = () => {
  const { showAuthModal, setShowAuthModal } = useAuth();
  const navigate = useNavigate();

  if (!showAuthModal) return null;

  const handleReconnect = () => {
    setShowAuthModal(false);
    navigate('/login');
  };

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal">
        <p>Vous ne pouvez pas effectuer cette action car vous êtes déconnecté. Veuillez vous reconnecter.</p>
        <button onClick={handleReconnect}>Se reconnecter</button>
      </div>
    </div>
  );
};

export default AuthModal;